import { styled } from 'styled-components';

const StyledLoaderContainer = styled.div`
  z-index: 1000000;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  position: fixed;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  background-color: #ddd;
`;

const StyledLoader = styled.div`
  border: 2px solid #ddd;
  border-radius: 50%;
  border-top: 2px solid #5f5f5f;
  border-left: 2px solid #5f5f5f;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 400ms linear infinite;
  animation: spin 400ms linear infinite;
  position: absolute;
  top: 45%;
  left: 47%;

  @-moz-keyframes spin {
    0% {
      -moz-transform: rotate(0deg);
    }

    100% {
      -moz-transform: rotate(360deg);
    }
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }
`;

const Loader = () => (
  <StyledLoaderContainer>
    <StyledLoader />
  </StyledLoaderContainer>
);

export default Loader;
